import React from 'react'
import './About.css'

const AboutSection1 = () => {
  return (
    <>
    <div className='backdiv'> 
      <div className='border-content'>
           <p className='main-content'>At Saptveda, we believe in building more than businesses - we build relationships, trust, and long-term value. As a group, we bring together diverse expertise in real estate consulting, construction, portfolio management, and financial services to serve our clients efficiently under one unified platform.Our operations are driven by a strong governance philosophy that balances the interests of all stakeholders. We strive to create a work environment that empowers our employees, delivers genuine value to our customers, and contributes positively to the communities we serve. Guided by ethical practices, transparency, and responsibility, Saptveda is dedicated to sustainable growth while fulfilling its duty toward society and the nation. As we continue to evolve and explore new opportunities, our focus remains on excellence, integrity, and meaningful impact.</p> 
           </div>       
    </div>
 <div className="backdiv">
  <div className="founder-grid">
    <div className='founder-border'>
      <h2 className="sub-head">Our Founder</h2>
      <h3 className="found-head">Ankit Singhal</h3>

      <p className="main-content">
        <b>Mr. Ankit Singhal</b> is the <b>Founder</b> of Saptveda Group with over 19 years of
        experience in real estate and the technical implementation of emerging
        technologies. He has served as Director at K.M. Enterprises, contributing
        to facility management and humanitarian services during the COVID period.
        He has also held leadership roles across multiple companies, working on multiple residential projects across Delhi NCR and other cities. His vision, industry expertise, and ethical leadership form the foundation of Saptveda.
      </p>
        <p className="quote">
        <b>“Success is not only today’s achievement, but a pile of yesterday’s failures.”</b>
      </p>
    </div>



     <div className='founder-border'>
      <h2 className="sub-head">Co-Founder</h2>

      <h3 className="found-head">Krishna Yadav</h3>
  

      <p className="main-content">
       <b> Ms. Krishna Yadav</b> is the <b>Co-Founder</b> of Saptveda Group with more than 4 years
        of experience in real estate operations, CRM, and MIS management. She has
        worked closely with the Founder in implementing ethical business practices,
        strategic planning, and team leadership.
        With her background in teaching and the education sector, she laid the
        foundation for Saptveda Educations, strengthening the group’s commitment
        to knowledge, growth, and social responsibility.
      </p>
        <p className="quote">
        <b>“Real estate is investing right amount, at the right time, in the right opportunity.”</b>
      </p>
    </div>
  </div>

</div>

           </>
  )
}

export default AboutSection1